import { formatNumberToPercentage as m, numberFormat as o, currencyFormat as u } from "./index.es552.js";
const a = ({
  value: r,
  maxDecimal: e,
  shorten: t,
  type: n,
  signIndicator: c
}) => {
  if (!r) return r;
  switch (n) {
    case "currency":
      return u(+r, e ?? 2, void 0, t, t);
    case "number":
      return o({
        number: +r,
        shorten: t,
        formatThousands: t,
        maximumFractionDigits: e ?? 2,
        signIndicator: c
      });
    case "percentage":
      return m({
        percentage: +r,
        fractionDigits: e,
        signIndicator: c
      });
    case "default":
      return r;
  }
};
export {
  a as getNumericFormat
};
//# sourceMappingURL=index.es732.js.map
